var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreperation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 983.56578,
    height: 543.49805,
    viewBox: "0 0 983.56578 543.49805",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      userSelect: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M990.42528,462.251h-682a9.01015,9.01015,0,0,1-9-9v-266a9.01015,9.01015,0,0,1,9-9h682a9.01016,9.01016,0,0,1,9,9v266A9.01016,9.01016,0,0,1,990.42528,462.251Zm-682-282a7.00817,7.00817,0,0,0-7,7v266a7.00818,7.00818,0,0,0,7,7h682a7.00818,7.00818,0,0,0,7-7v-266a7.00818,7.00818,0,0,0-7-7Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.86069,350.47571H577.053c-3.11512-27.70709,3.75787-48.359,0-59.76919h49.80774A311.80966,311.80966,0,0,0,626.86069,350.47571Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#ff6584",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86069,603.47571H109.053c-3.11512-27.70709,3.75787-48.359,0-59.76919h49.80774A311.80966,311.80966,0,0,0,158.86069,603.47571Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#ff6584",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.86069,405.47571H880.053c-3.11512-27.70709,3.75787-48.359,0-59.76919h49.80774A311.80966,311.80966,0,0,0,929.86069,405.47571Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.63418,376.03983h-49.8077c1.86758-22.98178,7.88909-44.44186,0-59.76922h49.8077Q384.70063,346.1552,370.63418,376.03983Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.63418,453.03983h-49.8077c1.86758-22.98178,7.88909-44.44186,0-59.76922h49.8077Q424.70063,423.1552,410.63418,453.03983Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.63418,312.03983h-49.8077c1.86758-22.98178,7.88909-44.44186,0-59.76922h49.8077Q864.70063,282.1552,850.63418,312.03983Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.63418,390.03983h-49.8077c1.86758-22.98178,7.88909-44.44186,0-59.76922h49.8077Q717.70063,360.1552,703.63418,390.03983Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.54867,325.12531h49.80768c3.115-22.98593-3.75787-44.44531,0-59.76922H421.54867Q407.48233,295.24068,421.54867,325.12531Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.42528,215.251h-93a2,2,0,0,1,0-4h93a2,2,0,0,1,0,4Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.42528,215.251h-93a2,2,0,0,1,0-4h93a2,2,0,0,1,0,4Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.42528,215.251h-93a2,2,0,1,1,0-4h93a2,2,0,0,1,0,4Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.20817,
    y: 1,
    width: 2,
    height: 282,
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.20817,
    y: 1,
    width: 2,
    height: 282,
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.61946,
    cy: 208.15244,
    r: 53.51916,
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.40379,721.749H243.64451a6.50753,6.50753,0,0,1-6.5-6.5V592.23535a6.50753,6.50753,0,0,1,6.5-6.5h14.75928a6.50753,6.50753,0,0,1,6.5,6.5V715.249A6.50752,6.50752,0,0,1,258.40379,721.749Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.59617,721.749H272.83641a6.50752,6.50752,0,0,1-6.5-6.5V592.23535a6.50753,6.50753,0,0,1,6.5-6.5h14.75976a6.50753,6.50753,0,0,1,6.5,6.5V715.249A6.50752,6.50752,0,0,1,287.59617,721.749Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.4199,568.1748a6.5284,6.5284,0,0,1-2.0039-.31738,6.45607,6.45607,0,0,1-3.78906-3.22461l-6.72461-13.13867a6.4992,6.4992,0,0,1,2.82519-8.74707l109.50342-56.04785a6.5,6.5,0,0,1,8.74805,2.82519l6.72461,13.13868a6.5,6.5,0,0,1-2.82422,8.74707L152.375,567.458A6.48022,6.48022,0,0,1,149.4199,568.1748Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.78221,511.12109a6.44844,6.44844,0,0,1-4.21484-1.56054l-11.2168-9.5918a6.50851,6.50851,0,0,1-.71582-9.165l79.94873-93.49219a6.50635,6.50635,0,0,1,9.16406-.71484h.00049l11.21728,9.59277a6.499,6.499,0,0,1,.71534,9.16407L304.7324,508.8457a6.46068,6.46068,0,0,1-4.43408,2.25586C300.12547,511.11523,299.95311,511.12109,299.78221,511.12109Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.75447,332.877c-1.74158-17.35888-13.15-33.959-30.56666-38.47672A37.30013,37.30013,0,0,0,212.7127,296.711,33.7294,33.7294,0,0,0,196.757,313.88172a47.97965,47.97965,0,0,0-3.40192,23.3114,61.3392,61.3392,0,0,0,8.11742,24.55595c4.72412,8.32858,10.86712,15.77442,17.31505,22.815,6.56956,7.17342,14.00236,13.77316,19.53044,21.82661,4.90273,7.14244,8.8453,16.84276,4.01352,25.06345a18.51071,18.51071,0,0,1-18.18309,8.49374,15.41384,15.41384,0,0,1-4.94667-1.64208c-1.7026-.909-3.21977,1.67982-1.51416,2.59041,6.4702,3.45432,14.51484,2.67156,20.62728-1.21293,7.04537-4.47737,10.19028-12.37936,8.86984-20.54779-1.50552-9.31337-7.9997-17.30976-14.23514-24.01342-6.51347-7.00258-13.33527-13.68909-19.3683-21.12837-5.95933-7.3484-11.28-15.45906-14.46971-24.41751a51.06027,51.06027,0,0,1-2.61-23.38746c.95038-7.53727,3.88112-15.00574,9.1394-20.58239a31.11511,31.11511,0,0,1,22.38492-9.44562,35.19806,35.19806,0,0,1,23.59037,8.67326,42.74573,42.74573,0,0,1,13.028,21.71921,44.01781,44.01781,0,0,1,1.1102,6.3238c.19091,1.90286,3.19289,1.92257,3,0Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.4785,332.46875a5.501,5.501,0,0,1-1.71826-10.72461l14.24365-4.70312a5.49949,5.49949,0,1,1,3.44873,10.44433L259.209,332.18848A5.50474,5.50474,0,0,1,257.4785,332.46875Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.64207,607.751H187.16112a6.48639,6.48639,0,0,1-5.6294-9.75l83.24072-144.17676a6.62661,6.62661,0,0,1,1.04541-1.36719l.01612-.01562.00683-.00684a6.38568,6.38568,0,0,1,3.33936-1.74805c.084-.01562.16846-.03027.25342-.042a6.614,6.614,0,0,1,.96826-.07031h0a6.43275,6.43275,0,0,1,5.6289,3.25L359.27147,598.001a6.5,6.5,0,0,1-5.6294,9.75Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6624,395.19567l-.05566-2c3.7207-.10351,7.001-.33691,9.46582-2.13769a6.148,6.148,0,0,0,2.38134-4.52832,3.51431,3.51431,0,0,0-1.15283-2.89453c-1.63574-1.38282-4.26855-.93555-6.188-.05469l-1.65478.75879,3.17334-23.19043,1.98144.27148-2.69922,19.72657c2.60791-.76661,5.02344-.4375,6.67823.96093A5.471,5.471,0,0,1,320.45244,386.6a8.13264,8.13264,0,0,1-3.2002,6.07324C314.08525,394.98767,309.96953,395.1029,306.6624,395.19567Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.19529,
    y: 184.87048,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.76091,519.98179,930.49187,453.139a6.49874,6.49874,0,0,1-1.92529-8.98828l8.02-12.39062a6.50783,6.50783,0,0,1,8.98828-1.92578l103.26953,66.84277a6.50908,6.50908,0,0,1,1.92529,8.98926l-8.02,12.39062a6.50614,6.50614,0,0,1-8.98877,1.92481Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.06389,519.1544,990.8945,495.04948a6,6,0,0,1-2.44627-7.91217L998.449,467.04455a6,6,0,0,1,9.03592-2.07743l41.12561,31.72085a6.01089,6.01089,0,0,1,1.77965,8.295l-8.02158,12.393A6.01072,6.01072,0,0,1,1034.06389,519.1544Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930.04663,
    cy: 209.93676,
    r: 53.51916,
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.19646,715.03355V592.0189a6.50753,6.50753,0,0,1,6.5-6.5h14.75977a6.50753,6.50753,0,0,1,6.5,6.5V715.03355a6.50753,6.50753,0,0,1-6.5,6.5h-14.75977A6.50753,6.50753,0,0,1,1040.19646,715.03355Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.00408,715.03355V592.0189a6.50752,6.50752,0,0,1,6.5-6.5h14.75976a6.50752,6.50752,0,0,1,6.5,6.5V715.03355a6.50753,6.50753,0,0,1-6.5,6.5h-14.75976A6.50753,6.50753,0,0,1,1011.00408,715.03355Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.8405,599.48081V457.00523a6.50753,6.50753,0,0,1,6.5-6.5h37.68555a35.91777,35.91777,0,0,1,35.877,35.877V599.48081a6.50752,6.50752,0,0,1-6.5,6.5h-67.0625A6.50753,6.50753,0,0,1,998.8405,599.48081Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.54851,403.057l.05566-2c-3.7207-.10351-7.001-.33691-9.46582-2.13769A6.148,6.148,0,0,1,979.757,394.391a3.51431,3.51431,0,0,1,1.15283-2.89453c1.63574-1.38282,4.26855-.93555,6.188-.05469l1.65478.75879-3.17334-23.19043-1.98144.27148,2.69922,19.72656c-2.60791-.7666-5.02344-.4375-6.67823.96094a5.471,5.471,0,0,0-1.86035,4.49219,8.13264,8.13264,0,0,0,3.2002,6.07324C984.12566,402.849,988.24138,402.96421,991.54851,403.057Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.80992,
    y: 192.73179,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.30242,596.39487l-13.0376-6.91894a6.50858,6.50858,0,0,1-2.69483-8.78906l57.66456-108.66114a6.50934,6.50934,0,0,1,8.78906-2.69433l13.03711,6.91894a6.50773,6.50773,0,0,1,2.69531,8.78809L982.091,593.69956a6.49014,6.49014,0,0,1-8.78857,2.69531Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.90524,484.80822l-25.28261,45.09167a6,6,0,0,1-7.67107,3.12114l-20.88212-8.22629a6,6,0,0,1-2.85081-8.82249l28.04672-45.714a6.01088,6.01088,0,0,1,8.1101-2.49012l18.04,8.92017A6.01071,6.01071,0,0,1,1043.90524,484.80822Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.31606,353.04649c-9.1763,1.43424-20.28239,2.90266-27.18226-4.82147a10.89043,10.89043,0,0,1-2.49885-10.91381c1.33064-3.79408,4.76164-6.68489,8.36076-8.25489,5.38218-2.34779,11.51149-2.20341,17.26121-2.13842a1.5009,1.5009,0,0,0,0-3c-5.869-.06634-12.0102-.12232-17.56653,2.04229-4.37314,1.70368-8.42319,4.86186-10.40316,9.209-4.34039,9.52961,3.67544,18.836,12.7333,21.15581,6.60874,1.69257,13.471.64933,20.093-.38567,1.90183-.29725,1.09427-3.18852-.79752-2.89284Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.54867,498.12531h49.80768c3.115-22.98593-3.75787-44.44531,0-59.76922H897.54867Q883.48233,468.24068,897.54867,498.12531Z",
    transform: "translate(-108.21711 -178.25098)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreperation);
export default __webpack_public_path__ + "static/media/preperation.1f11a1a2859d37cdbca1441748111cf4.svg";
export { ForwardRef as ReactComponent };